import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";


import { AuthenticationService } from "../../components/AuthenticationService";
import LocaleSelect from "../../components/Locale/LocaleSelect";
import faviconOixio from "../../css/img/favicon.png";

import "./LoginPage.css";

const ForgotPasswordPage = () => {
    const [submitting, setSubmitting] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const { i18n, t } = useTranslation(["pages", "common"]);

    useEffect(() => {
        document.title = i18n.t("common:document.title");
    }, [i18n.language]);

    const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setSubmitting(true);
        setErrorMessage("");

        if (!email) {
            setSubmitting(false);
            setErrorMessage(t("login.errorEmail"));
            return;
        }

        try {
            await AuthenticationService.forgotPassword(email, i18n.language);
            setSubmitting(false);
            setRedirect(true);
        } catch {
            setSubmitting(false);
            setErrorMessage(t("login.errorSubmit"));
        }
    };

    if (redirect) {
        return <Navigate replace to="/" />;
    }

    return (
        <div className="container-fluid">
            <Card className="login-clean no-border mt-5">
                <Card.Body>
                    <Row>
                        <form
                            method="post"
                            className="login-clean-form"
                            onSubmit={handleSubmit}
                            noValidate
                        >
                            <Row>
                                <Col className="mb-2 ms-auto">
                                    <LocaleSelect />
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <img
                                    src={faviconOixio}
                                    alt="oixio favicon"
                                    className="favicon_login"
                                />
                                <span className="logo-title">
                                    {t("login.forgotPassword")}
                                </span>
                            </Row>

                            <div className="text-forgotPassword my-3">
                                <span>{t("resetPassword.resetPasswordText")}</span>
                            </div>
                            <div className="form-group mt-2">
                                <input
                                    className="form-control input-field-font mt-2"
                                    type="email"
                                    name="email"
                                    placeholder={t("login.email")}
                                    value={email}
                                    onChange={handleChangeEmail}
                                />
                            </div>
                            <div className="form-group mt-2">
                                <Row>
                                    <button
                                        className="btn d-grid btn-login shadow-sm  mt-3 mb-3"
                                        type="submit"
                                        disabled={submitting}
                                    >
                                        {t("resetPassword.sendInstructions")}
                                    </button>
                                </Row>
                                <Row className="ms-auto">
                                    <Col>
                                        <a
                                            href="/"
                                            className="btn btn-link btn-navigateBack btn-forgotPassword"
                                            role="button"
                                        >
                                            {t("login.back")}
                                        </a>
                                    </Col>
                                </Row>
                            </div>
                            <div className="input-error-login text-danger">
                                {errorMessage}
                            </div>
                        </form>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ForgotPasswordPage;
